/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasourceai3Inputs */

const en_casedatasourceai3 = /** @type {(inputs: Casedatasourceai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const pt_casedatasourceai3 = /** @type {(inputs: Casedatasourceai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA`)
};

/**
* | output |
* | --- |
* | "AI" |
*
* @param {Casedatasourceai3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasourceai3 = /** @type {((inputs?: Casedatasourceai3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasourceai3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasourceai3(inputs)
	return pt_casedatasourceai3(inputs)
});
export { casedatasourceai3 as "caseDataSourceAi" }